import { Container, Typography } from "@material-ui/core";
import { default as React } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { useLocation } from "wouter";
import firebase from "./firebase";
import PrivacyPolicy from "./PrivacyPolicy";
import Terms from "./Terms";

export default Login;
function Login() {
  const [, setLocation] = useLocation();
  const landingPath = "/upload";
  const uiConfig = {
    signInFlow: "popup",
    signInSuccessUrl: landingPath,
    signInOptions: [
      firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
  };

  const [user] = useAuthState(firebase.auth());
  if (user) {
    setLocation(landingPath);
  }

  return (
    <div>
      <Container
        maxWidth="sm"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography style={{ marginTop: "100px" }}>投稿にはログインが必要です</Typography>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        <PrivacyPolicy></PrivacyPolicy>
        <Terms></Terms>
      </Container>
    </div>
  );
}
